import { useHasSeenNewFeature } from 'common/hooks/useHasSeenNewFeature';
import Callout from 'components/_core/Callout';

import locales from './locales';

const PresetsCallout = () => {
  const [hasSeenInvoicePresets, setHasSeenInvoicePresets] =
    useHasSeenNewFeature('INVOICE_PRESETS');

  return hasSeenInvoicePresets ? null : (
    <Callout marginBottom="space-16">
      <Callout.Content>{locales.content}</Callout.Content>
      <Callout.Button onClick={() => setHasSeenInvoicePresets(true)}>
        {locales.button}
      </Callout.Button>
    </Callout>
  );
};

export default PresetsCallout;
